/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../../util/headers"

// Not working for some reason
// export const getUnitDetail = (baseUrl, unit_id) => {
//   const path = `${baseUrl}/backend/units/${unit_id}`
//   return axios.get(path)
//     .then(({ data, status }) => ({ response: data, status }))
//     .catch(error => { error })
// }

export const getUnitDetail = (baseUrl, unit_id) => {
  const path = `${baseUrl}/backend/units/details`
  return axios.get(path, { params: { id: unit_id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
}

export const updateUnitDetail = (baseUrl, form) => {
  const path = `${baseUrl}/backend/units`
  return axios.put(path, form, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const createUnits = (baseUrl, unit) => {
  const path = `${baseUrl}/backend/units`
  return axios.post(path, unit, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const changeUnitState = (baseUrl, id) => {
  const path = `${baseUrl}/backend/units/change-status`
  return axios.post(path, { id }, headers())
}